var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('border-customs-v3',{attrs:{"config":_vm.getConfig,"default-border":[1,1,1,1],"default-radius":[0,0,0,0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }